import React, {Component, useState, useEffect} from 'react';
import {createRoot} from 'react-dom/client';
import CsfBrokerExportModal from '../includes/csf-broker-export-modal';
import CsfBrokerPagination from "../includes/csf-broker-pagination";
import CsfBrokerSearch from "../includes/csf-broker-search";
import CsfBrokerSearchCompliance from "../includes/csf-broker-search-compliance";
import CsfBrokerDashboard from "../includes/csf-broker-dashboard";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import {startLoadingSpinner, stopLoadingSpinner} from '../includes/utils';


class CsfPivotalBrokerCompliances extends Component {

  constructor(props) {
    super(props);
    this.state = {
      token: '',
      complianceSearchValue: '',
      complianceSortValue: 'Member_Number',
      complianceDisplayValue: '',
      data: [],
      periods: [],
      selectedPeriods: '',
      startRow: 1,
      searchTotal: 0,
      pageSize: 25,
      totalPages: 0,
      activePage: 1,
    };
  }

  componentDidMount() {
    startLoadingSpinner();
    this.fetchAccessToken();
  }

  /*
  * Method to call drupal api to get the access token of the session
  * */
  fetchAccessToken = () => {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest()
      .then(response => {
        if (response && response.api_access_token) {
          this.setState({token: response.api_access_token}, () => {
            this.fetchApiDataPeriod();
          });
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  };

  /*
* Method to call api: call from class extending from PivotalSearchApi
* */
  fetchApiDataPeriod = () => {
    const requestData = {
      search: 'CSF_CRC_Period_REST',
    };
    const pivotalSearchApi = new PivotalSearchApi(this.props.apiUrl, this.props.apiEnv, this.state.token);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Courtier')
      .then(response => {
        if (response && response.success && response.payload && response.payload.data && response.payload.data.rows && response.payload.data.rows.length >= 0) {
          this.setState({ periods: response.payload.data.rows, selectedPeriods: response.payload.data.rows[0].GSFT_Period_Id }, () => {
            this.fetchApiData(); // This will fetch API data using the updated token
          });

        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  };


  /*
  * Method to call api: call from class extending from PivotalSearchApi
  * */
  fetchApiData = () => {
    const requestData = this.buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(this.props.apiUrl, this.props.apiEnv, this.state.token);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Courtier')
      .then(response => {
        stopLoadingSpinner();
        if (response &&
          response.success &&
          response.payload &&
          response.payload.data &&
          response.payload.data.rows &&
          response.payload.data.rows.length >= 0) {
          let totalPages = Math.ceil(response.payload.data.searchTotal / this.state.pageSize);
          if (totalPages == 0 || this.state.pageSize === 'all') {
            totalPages = 1;
          }
          this.setState({
            totalPages: totalPages, data: response.payload.data.rows, searchTotal: response.payload.data.searchTotal
          });
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  };

  /*
  * Method to build the body array for the request
  * */
  buildMainBodyDataResquest = () => {
    let requestData = {
      maxRows: this.state.pageSize,
      startRow: this.state.startRow,
      matchCondition: 1,
      ParameterValues: [this.state.complianceDisplayValue, this.state.selectedPeriods],
      search: 'REDU_Conformite_QUERY_REST',
    };

    if (this.state.complianceSortValue !== '') {
      requestData.sort = this.getSortingQuery(this.state.complianceSortValue);
    }

    let searchConditions = this.buildSearchConditionsContains(this.state.complianceSearchValue, ["Member_Number", "Member_LastName", "Member_FirstName"]);

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }

    return requestData;
  }

  /*
  * Method to build the sort condition.
  * */
  getSortingQuery = (sortingQuery) => {
    return [{
      property: sortingQuery, direction: "ASC", sortPriority: 1,
    }];
  }

  /*
  * Method to build the search conditions
  * */
  buildSearchConditionsContains = (search, fieldsToSearch) => {
    // Arbitrary limit to prevent huge inputs from overloading the number of criteria
    const maxSearchTerms = 5;
    if (!search) {
      return [];
    }

    // Split the search string into individual terms
    let searchTerms = search.split(" ");
    if (searchTerms.length <= 1) {
      searchTerms = [search];
    }

    const searchConditions = [];
    let termCount = 0;
    for (const term of searchTerms) {
      if (!term) {
        continue;
      }

      if (termCount >= maxSearchTerms) {
        break;
      }

      for (const field of fieldsToSearch) {
        searchConditions.push({
          field: field, operator: 7, value: term, connective: 0,
        });
      }
      termCount++;
    }

    return searchConditions;
  }

  /*
  * Method to handle the "apply" submit button
  * */
  handleSubmitFilteringSearch = (event) => {
    event.preventDefault();
    startLoadingSpinner();
    this.setState({pageSize: 25, startRow: 1, activePage: 1}, () => {
      this.fetchApiData();
    });
  };

  /*
* Method to handle the export button
* */
  handleBrokerExportBtn = (event) => {
    event.preventDefault();
    startLoadingSpinner();
  };

  /*
  * Method to handle the input changes of the search text input
  * */
  handleComplianceSearchInputChange = (event) => {
    this.setState({complianceSearchValue: event.target.value});
  };

  /*
  * Method to handle the input changes of the select "sort" input
  * */
  handleComplianceSortInputChange = (event) => {
    this.setState({complianceSortValue: event.target.value});
  };

  /*
  * Method to handle the input changes of the select "Display" input
  * */
  handleComplianceDisplayInputChange = (event) => {
    this.setState({complianceDisplayValue: event.target.value});
  };

  /*
  * Method to handle the input changes of the select pagesize
  * */
  handlePageSizeChange = (event) => {
    event.preventDefault();
    startLoadingSpinner();
    this.setState({pageSize: event.target.value, startRow: 1, activePage: 1}, () => {
      this.fetchApiData();
    });
  };

  /*
  * Method to handle the input changes of the select period field
  * */
  HandleOnChangePeriod = (event) => {
    this.setState({selectedPeriods: event.target.value}, () => {
      startLoadingSpinner();
      this.fetchApiData();
    });
  };

  /*
  * Method to get the current date from the period_ID
  * */
  getDatesByPeriodId = (targetPeriodId) => {
    const resultPeriod = this.state.periods.find(period => period?.GSFT_Period_Id === targetPeriodId);
    return resultPeriod ? {
      GSFT_Start_Date: resultPeriod.GSFT_Start_Date,
      GSFT_End_Date: resultPeriod.GSFT_End_Date
    } : null;
  }

  /*
  * Method to handle the date formating.
  * */
  formatDate = (dateString) => {
    const language = document.querySelector('html').getAttribute('lang');
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const formattedDate = new Date(dateString).toLocaleDateString(language, options);

    // Format the date with "1st" for the 1st day
    const formattedDateWithOrdinal = formattedDate.replace(/\b1\b/, (match) => {
      // Use the correct ordinal suffix based on the language
      if (language === 'fr') {
        return '1er';
      } else {
        return '1st';
      }
    });

    return formattedDateWithOrdinal;
  }

  /*
  * Method to handle the page change
  * */
  handlePageChangeChange = (event) => {
    let linkAnchor = event.target;
    if (linkAnchor.tagName !== 'A') {
      linkAnchor = event.target.closest('a');
    }
    const page = linkAnchor.getAttribute('data-page');
    const startRow = (page - 1) * this.state.pageSize + 1;
    event.preventDefault();
    startLoadingSpinner();
    this.setState({activePage: page, startRow: startRow}, () => {
      this.fetchApiData();
    });
  };

  render() {

    const displayDashboard = document.getElementById('CsfPivotalBrokerCompliances').getAttribute('data-show-dashboard')

    const {
      complianceSearchValue,
      complianceSortValue,
      complianceDisplayValue,
      data,
      searchTotal,
      pageSize,
      totalPages,
      activePage,
      periods,
      selectedPeriods
    } = this.state;

    return (<div className="ajaxContentPlaceholder">
      <div className="medium-wrapper">
        <div className="mt-3 js-form-item form-item js-form-type-select form-group">
          <label htmlFor="compliance_period">{window.Drupal.t('search.period')}</label>
          <select value={selectedPeriods} onChange={this.HandleOnChangePeriod}
                  data-drupal-selector="compliance_period"
                  id="compliance_period"
                  name="compliance_period"
                  className="w-100 form-select form-text">
            {Object.entries(periods).map(([key, value]) => {
              return (
                <option key={key} value={value.GSFT_Period_Id}>
                  { window.Drupal.t('select.period.label') + ' ' +value.GSFT_Period_Name +' ('+ new Date(value.GSFT_Start_Date).getFullYear() +'-'+new Date(value.GSFT_End_Date).getFullYear()+')'}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div className="primary">
        <div className="space-between-wrapper">
          <div>
            <div className="heading-regular-medium">
              {selectedPeriods && selectedPeriods !== ''
                ? window.Drupal.t('broker.compliance.titlePage.currentPeriod.start') + ' ' + this.formatDate(this.getDatesByPeriodId(selectedPeriods).GSFT_Start_Date) + ' '+window.Drupal.t('broker.compliance.titlePage.currentPeriod.stopword')+' ' +  this.formatDate(this.getDatesByPeriodId(selectedPeriods).GSFT_End_Date)
                : ''
              }
            </div>
            <div className="mt-2 mb-2 heading-large-bold">
              {window.Drupal.t('broker.compliance.titlePage')}
            </div>
          </div>
          <button type="button" className="button btn-outlined btn-larger btn-with-icon trigger-export_modal" data-toggle="modal" data-target="#export_modal">
            <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            { window.Drupal.t("Export") }
          </button>
        </div>

        <div className="inner-wrapper mt-2">
          <CsfBrokerSearch
            listType={'compliance'}
            searchTotal={searchTotal}
            searchValue={complianceSearchValue}
            sortValue={complianceSortValue}
            displayValue={complianceDisplayValue}
            handleSearchInputChange={this.handleComplianceSearchInputChange}
            handleSortInputChange={this.handleComplianceSortInputChange}
            handleDisplayInputChange={this.handleComplianceDisplayInputChange}
            handleSubmitFilteringSearch={this.handleSubmitFilteringSearch}
            searchPlaceholder={window.Drupal.t('search.placeholder.broker.compliance')}
          />

          {displayDashboard === '1' && (
            <CsfBrokerDashboard
              apiUrl={this.props.apiUrl}
              apiEnv={this.props.apiEnv}
              token={this.state.token}
            />
          )}

          <CsfBrokerSearchCompliance
            data={data}
            selectedPeriods={selectedPeriods}
          />

          <CsfBrokerPagination
            pageSize={pageSize}
            totalPages={totalPages}
            activePage={activePage}
            searchTotal={searchTotal}
            handlePageSizeChange={this.handlePageSizeChange}
            handlePageChangeChange={this.handlePageChangeChange}
          />

          <CsfBrokerExportModal
            listType={'compliance'}
            handleBrokerExportBtn={this.handleBrokerExportBtn}
            apiUrl={this.props.apiUrl}
            apiEnv={this.props.apiEnv}
            token={this.state.token}
            name={'broker-compliance'}
          />
        </div>
      </div>
    </div>);
  }
}

export default CsfPivotalBrokerCompliances;

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalBrokerCompliances');

  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");

    root.render(<CsfPivotalBrokerCompliances
      apiUrl={apiUrl}
      apiEnv={apiEnv}
    />);
  }
});
